// item 35 — brand-colour validation. A required brand colour must be a full 6-digit
// hex (#rrggbb); an optional one (success/warning/error) may also be blank/null.
// Extracted from BrandFields so the BrandWizard's "can advance" gate is unit-testable
// without mounting the component.

export const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;

export const isValidHex = (value: string | null): boolean => value !== null && HEX_PATTERN.test(value);

export const isValidOptionalHex = (value: string | null): boolean => (
  value === null || value === '' || HEX_PATTERN.test(value)
);
